import * as types from './actionTypes';
import { push } from 'connected-react-router';

export const ChangeFormStep = (formName, stepNumber) => ({
    type: types.CHANGE_FORM_STEP,
    formName,
    stepNumber
});

export const setFormCompleted = (formName, value) => ({
    type: types.CHANGE_FORM_COMPLETED_FLAG,
    formName,
    value
});

export const resetForm = formName => () => (
    Promise.resolve({
        type: types.RESET_FORM,
        formName
    })
)

export const resetCurrentForm = formName => ({    
        type: types.RESET_FORM,
        formName
})

export const redirectBackAndResetFormCompleted = (formName, redirectUrl) => dispatch  =>
{    
    dispatch(resetCurrentForm(formName))
    dispatch(push(redirectUrl));
}